import React from 'react';
import { motion } from 'motion/react';

export function SpotLight() {
  const features = [
    { icon: '📅', label: 'Financial Year', value: 'FY 2024–25 (not Jan–Dec)' },
    { icon: '₹', label: 'Currency', value: 'INR (not just $USD)' },
    { icon: '📋', label: 'Compliance', value: 'GST, TDS, Indian tax workflows' },
    { icon: '🕐', label: 'Time Zones', value: 'IST-first scheduling' },
  ];

  return (
    <section className="relative py-10 sm:py-16 md:py-32 px-5 overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #093A5B 0%, #0a4d6e 100%)',
      }}>

      {/* Spotlight Gradient */}
      <motion.div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(circle at 50% 50%, rgba(9, 58, 91, 0.3) 0%, transparent 70%)',
        }}
        initial={{ scale: 0, opacity: 0 }}
        whileInView={{ scale: 1.5, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
      />

      <div className="max-w-[1200px] mx-auto relative z-10">

        {/* One More Thing */}
        <motion.div
          className="text-center mb-8 sm:mb-10 md:mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div
            className="text-white/50 mb-4"
            style={{
              fontSize: '1.125rem',
              fontWeight: 400,
              fontStyle: 'italic',
            }}
          >
            One more thing...
          </div>
        </motion.div>

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="text-center mb-8 sm:mb-10 md:mb-20"
        >
          <h2 className="text-white mb-6">Built specifically for India.</h2>
        </motion.div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-[900px] mx-auto">
          {features.map((feature, idx) => (
            <motion.div
              key={idx}
              className="bg-white/5 backdrop-blur-sm rounded-2xl p-3 sm:p-5 md:p-8 border border-white/10"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5 + idx * 0.1, duration: 0.6 }}
              whileHover={{
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
                borderColor: 'rgba(255, 255, 255, 0.2)',
                scale: 1.02,
              }}
            >
              <div className="flex items-start gap-5">
                <div
                  className="flex-shrink-0 rounded-md md:rounded-xl bg-gradient-to-br from-[#093A5B] to-[#0F9D92] 
                  flex items-center justify-center spotLight_Icon"
                // style={{ fontSize: '1.75rem' }}
                // w-7 h-7 md:w-14 md:h-14
                >
                  <span className='spotLight_inner_Icon flex items-center justify-center'>

                    {feature.icon}
                  </span>
                </div>

                <div>
                  <div
                    className="text-white/60 mb-2 feature_label"
                    style={{
                      // fontSize: '0.875rem',
                      fontWeight: 500,
                      letterSpacing: '0.05em',
                    }}
                  >
                    {feature.label.toUpperCase()}
                  </div>

                  <div
                    className="text-white feature_value"
                    style={{ fontWeight: 500 }}
                  >
                    {feature.value}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Decorative India Emoji Map */}
        <motion.div
          className="absolute right-0 top-1/2 -translate-y-1/2 opacity-5 pointer-events-none"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 0.05, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.5 }}
        >
          <svg width="400" height="500" viewBox="0 0 400 500" fill="white">
            <text x="50" y="250" fontSize="400" fontWeight="bold">
              🇮🇳
            </text>
          </svg>
        </motion.div>
      </div>
    </section>
  );
}
